import { ConsoleLogger } from '@cloudflare-monorepo/utils/logging/logger.ts';

const defaultLogLevel = import.meta.env.PROD ? 'INFO' : 'DEBUG';

export const GlobalLogger = new ConsoleLogger('notificator-ui', defaultLogLevel);
